import { render } from "./LineChartE.vue?vue&type=template&id=a4801290&scoped=true"
import script from "./LineChartE.vue?vue&type=script&lang=ts"
export * from "./LineChartE.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-a4801290"

export default script